import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { parseSearch, getDefaultHeaderObj } from '../../../request-contract-helper';

// this odata api require date info, it does not impact response, provide one here
const yesterday = new Date(Date.now() - 864e5);
// odata use the yyyy-mm-dd format;
const dateString = yesterday.toISOString().split('T')[0];

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
    select = ['AdExtension'],
    pageSize = 100,
    count = true,
  } = variables;

  const { descriptor } = locator;
  const {
    cid,
    aid,
    cpid,
  } = descriptor;

  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(cpid)
    .AdExtensionAssociations;

  const search = {
    top: pageSize,
    select,
    count,
    filter: {
      where: "AdExtension/Status eq Enum.AdExtensionStatus'Active'",
    },
  };

  const parsedSearch = {
    ...parseSearch(search, entity),
    startdate: dateString,
    enddate: dateString,
    adextensiontype: 'CallAdExtension',
  };
  const searchCompact = _.omit(parsedSearch, x => _.isNull(x) || _.isUndefined(x));
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return `${entity.path}${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign:ad_extension_association',
  verb: requestVerbs.GET,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  keySelector: adExtensionAssociation => adExtensionAssociation.AdExtension.Id,
  parentKeySelector: variables => variables.locator.descriptor.cpid,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: adExtensionAssociation => adExtensionAssociation.AdExtension.Id,
  processorFn: response => response.value,
});
